import navigationSliceReducer from "../slices/navigationSlice";
import authSliceReducer from "../slices/authSlice";
import loadingBarSliceReducer from "../slices/loadingBarSlice";
import selfSliceReducer from "../slices/selfSlice";
import userSliceReducer from "../slices/usersSlice";
import rolesSliceReducer from "../slices/rolesSlice";
import metaSliceReducer from "../slices/metaSlice";
import enterpriseSliceReducer from "../slices/enterpriseSlice";
import globalSliceReducer from "../slices/globalSlice";
import learningObjectsReducer from "../slices/learningObjectsSlice";
import uploadReducer from "../slices/uploadSlice";
import learningMilestoneReducer from "../slices/learningMilestoneSlice";
import learningPathwayReducer from "../slices/learningPathwaySlice";
import audienceReducer from "../slices/audienceSlice";
import customFieldReducer from "../slices/customFieldSlice";
import reportReducer from "../slices/reportSlice";
import notificationReducer from "../slices/notificationSlice";
import certificateReducer from "../slices/certificateSlice";

const reducers = {
  audiences: audienceReducer,
  auth: authSliceReducer,
  customFields: customFieldReducer,
  enterprises: enterpriseSliceReducer,
  global: globalSliceReducer,
  learningMilestones: learningMilestoneReducer,
  learningObjects: learningObjectsReducer,
  learningPathways: learningPathwayReducer,
  loadingBar: loadingBarSliceReducer,
  meta: metaSliceReducer,
  navigation: navigationSliceReducer,
  notifications: notificationReducer,
  reports: reportReducer,
  roles: rolesSliceReducer,
  self: selfSliceReducer,
  uploads: uploadReducer,
  users: userSliceReducer,
  certificates: certificateReducer,
};

export default reducers;
